var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWatchyourwordsappearinstantly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8077 7.44472C20.7224 2.74516 16.0381 0 12 0C7.96183 0 3.27751 2.74521 0.191777 7.44472C0.0922626 7.59627 0 7.79813 0 8C0 8.20207 0.0922626 8.40354 0.191777 8.55528C3.27756 13.2548 7.96183 16 12 16C16.0381 16 20.7224 13.2548 23.8077 8.55528C23.9077 8.40354 24 8.20206 24 8C24 7.79813 23.9077 7.59626 23.8077 7.44472ZM12 13.778C8.95679 13.778 6.48944 11.1909 6.48944 7.99995C6.48944 4.80896 8.9567 2.22193 12 2.22193C15.0432 2.22193 17.5105 4.80896 17.5105 7.99995C17.5105 11.1909 15.0432 13.778 12 13.778Z",
    fill: "#FF0004"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0928 7.3833C13.2621 7.3833 12.588 6.67668 12.588 5.80538C12.588 5.19353 12.9206 4.66421 13.4055 4.40222C12.9717 4.21537 12.4976 4.11083 11.9996 4.11083C9.95142 4.11083 8.29069 5.85217 8.29069 7.9998C8.29069 10.1472 9.95142 11.8888 11.9998 11.8888C14.0484 11.8888 15.7087 10.1476 15.7087 7.9998C15.7087 7.47748 15.609 6.98031 15.4308 6.52549C15.1814 7.03434 14.6765 7.3833 14.0928 7.3833Z",
    fill: "#FF0004"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchyourwordsappearinstantly);
export default __webpack_public_path__ + "static/media/Watch your words appear instantly.5b6be540d13227e58db77c20aa34fb44.svg";
export { ForwardRef as ReactComponent };